import { useId, type ReactNode } from "react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function FormField({
	label,
	labelAction,
	value,
	onChange,
	onBlur,
	placeholder,
	type,
	slot,
	autoFocus,
	hint,
	error,
	disabled,
}: {
	label: string;
	labelAction?: ReactNode;
	value: string;
	onChange: (value: string) => void;
	onBlur?: () => void;
	placeholder?: string;
	type?: string;
	slot?: string;
	autoFocus?: boolean;
	hint?: string;
	error?: string | null;
	disabled?: boolean;
}) {
	const id = useId();

	return (
		<div className="flex flex-col gap-1.5">
			<div className="flex items-center gap-1.5">
				<Label htmlFor={id}>{label}</Label>
				{labelAction}
			</div>

			<Input
				id={id}
				type={type}
				value={value}
				placeholder={placeholder}
				autoFocus={autoFocus}
				disabled={disabled}
				data-slot={slot}
				aria-invalid={!!error}
				aria-describedby={error || hint ? `${id}-feedback` : undefined}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
			/>

			{!!error && (
				<p id={`${id}-feedback`} className="text-sm text-destructive">
					{error}
				</p>
			)}

			{!error && !!hint && (
				<p id={`${id}-feedback`} className="text-xs text-muted-foreground">
					{hint}
				</p>
			)}
		</div>
	);
}
